export const MobileNavigation = () => {
  const nav = document.getElementById("mobile-navigation");
  if (!nav) return;

  const triggers = document.querySelectorAll("[data-mobile-menu-trigger]");
  const isMobile = window.matchMedia("(max-width: 568px)");

  function handleInitialMenuState(mediaQuery) {
    if (mediaQuery.matches) {
      // On mobile viewports: Ensure the menu is hidden by default on load
      if (!nav.classList.contains("-translate-x-full")) {
        nav.classList.add("-translate-x-full");
      }
    } else {
      // On desktop viewports: Remove the mobile utility class entirely
      // so desktop CSS layouts can render unhindered
      nav.classList.add("-translate-x-full");
    }
  }

  // Run immediately on page/component load
  handleInitialMenuState(isMobile);

  // Optional: Listen for screen resizing/orientation changes to clean up classes
  isMobile.addEventListener("change", handleInitialMenuState);

  // Toggle logic
  triggers.forEach((button) => {
    button.addEventListener("click", (e) => {
      // Prevent the click from bubbling up to the document
      // immediately, which would trigger the 'click outside' logic.
      e.stopPropagation();
      nav.classList.toggle("-translate-x-full");
    });
  });

  // Hide menu on outside click
  document.addEventListener("click", (e) => {
    const isClickInsideNav = nav.contains(e.target);
    const isMenuOpen = !nav.classList.contains("-translate-x-full");
    // If the menu is open and the click happened outside the nav
    if (isMenuOpen && !isClickInsideNav) {
      nav.classList.add("-translate-x-full");
    }
  });

  // mobile nav dropdowns
  const items = document.querySelectorAll(".mobile-menu-item");
  items.forEach((item) => {
    const trigger = item.querySelector(".submenu-trigger");
    const content = item.querySelector(".submenu-content");

    if (trigger && content) {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();

        // Toggle the 'open' state
        const isOpen =
          content.style.maxHeight && content.style.maxHeight !== "0px";

        if (isOpen) {
          content.style.maxHeight = "0px";
          trigger.classList.remove("rotate-180");
        } else {
          // Set maxHeight to the scrollHeight of the content
          content.style.maxHeight = content.scrollHeight + "px";
          trigger.classList.add("rotate-180");
        }
      });
    }
  });
  
};
